import axiosInstance from '@/store/axios'
import { rejectErrorApi } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    distributions ({ commit }, params) {
      return axiosInstance.get('/api/v1/distributions', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    createDistribution ({ dispatch }, distrib) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/distributions/create',
        data: distrib,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateDistribution ({ dispatch }, distrib) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/distributions/${distrib.id}/update`,
        data: distrib,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    patchDistribution ({ dispatch }, distrib) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/distributions/${distrib.id}`,
        data: distrib,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    deleteDistribution ({ commit }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/v1/distributions/${id}/delete`,
      })
        .then((result) => result.data)
        .catch((error) => rejectErrorApi(error))
    },
  },
}
